<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Data Analysis/ Market ແຜນປະຈຳປີ 
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab">

        <b-tab-item label="ຟອມແຜນປະຈຳປີ">
          <div class="columns" v-if="roleid==1">
            <div class="column is-3">
              <b-field label="ເລືອກປີ">
                <Multiselect
                  placeholder="ເລືອກ"
                  v-model.trim="selectedYear"
                  label="YEAR"
                  track-by="YEAR"
                  :options="yearList"
                  @input="onSelectedYear"
                >
                </Multiselect>
              </b-field>
            </div>
          </div>
          <div class="columns" v-if="selectedYear !=null">
            <div class="column is-5">
              <b-field :label="yearPlanTitle">
                <!-- <b-field label="ເລືອກປີ">
                  <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedYear"
                    label="YEAR"
                    track-by="YEAR"
                    :options="yearList"
                    @input="onSelectedYear"
                  >
                  </Multiselect>
                </b-field> -->
                <table width="100%" class="table">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">
                        #
                      </th>
                      <th class="has-text-left " width="20%">
                       ແຂວງ 
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈຳນວນ<br>ຕະຫຼາດ
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈຳນວນ<br>ລູກຄ້າ
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈຳນວນ<br>Order
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈຳນວນ<br>Rider
                      </th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in provinceList"
                      :key="data.ID"
                    >
                      <td
                        class="has-text-centered"
                      >
                        {{ index + 1 }}
                      </td>
                      <td
                        class="has-text-left"
                      >
                        {{data.NAME}}
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        <b-input type="number" v-model.trim="data.MARKET"> </b-input>
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        <b-input type="number" v-model.trim="data.CUSTOMER"> </b-input>
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        <b-input type="number" v-model.trim="data.ORDERS"> </b-input>
                      </td>
                      <td
                        class="has-text-centered"
                      >
                        <b-input type="number" v-model.trim="data.RIDER"> </b-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
              <b-field style="float: right; margin-right: 12px;"> 
                <b-field>
                  <button class="button is-info" @click="saveDasmPlan">
                    ບັນທຶກແຜນ
                  </button>
                </b-field>
              </b-field>
            </div>
            <div class="column is-1"></div>
            <div class="column is-6">
              <b-field :label="yearPlanTitlebyYear">
                <table width="100%" class="table">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">
                        #
                      </th>
                      <th class="has-text-left " width="20%">
                       ແຂວງ 
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br>ຕະຫຼາດ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br>ລູກຄ້າ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br>Order
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br>Rider
                      </th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(data, index) in planByYearList"
                      :key="data.PROVINCEID"
                    >
                      <td
                        class="has-text-centered td-heigher"
                      >
                        {{ index + 1 }}
                      </td>
                      <td
                        class="has-text-left td-heigher" 
                      >
                        {{data.PROVINCENAME}}
                      </td>
                      <td
                        class="has-text-centered td-heigher"
                      >
                        {{data.MARKET}}
                      </td>
                      <td
                        class="has-text-centered td-heigher"
                      >
                        {{data.CUSTOMER}}
                      </td>
                      <td
                        class="has-text-centered td-heigher"
                      >
                        {{data.ORDERS}}
                      </td>
                      <td
                        class="has-text-centered td-heigher"
                      >
                        {{data.RIDER}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
              <!-- <b-field style="float: right; margin-right: 12px;"> 
                <b-field>
                  <button class="button is-info" @click="saveDasmPlan">
                    ບັນທຶກແຜນ
                  </button>
                </b-field>
              </b-field> -->
            </div>
          </div>
 
          
        </b-tab-item>
        <b-tab-item label="ລາຍການແຜນປະຈຳປີ">
          <b-field label="ລາຍການແຜນປະຈຳປີ">
            <table width="100%" class="table">
              <thead>
                <tr>
                  <th class="has-text-centered " width="5%">
                    #
                  </th>
                  <th class="has-text-left " width="20%">
                    ແຜນປີ 
                  </th>
                  <th class="has-text-centered " width="15%">
                    ຈຳນວນ<br>ຕະຫຼາດ
                  </th>
                  <th class="has-text-centered " width="15%">
                    ຈຳນວນ<br>ລູກຄ້າ
                  </th>
                  <th class="has-text-centered " width="15%">
                    ຈຳນວນ<br>Order
                  </th>
                  <th class="has-text-centered " width="15%">
                    ຈຳນວນ<br>Rider
                  </th>
                  <th class="has-text-centered " width="10%">
                    ລາຍລະອຽດ
                  </th>
                  
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="(data, index) in yearOfPlanList"
                  :key="data.YEAR"
                >
                  <td
                    class="has-text-centered td-heigher"
                  >
                    {{ index + 1 }}
                  </td>
                  <td
                    class="has-text-left td-heigher" 
                  >
                    {{data.YEAR}}
                  </td>
                  <td
                    class="has-text-centered td-heigher"
                  >
                    {{data.MARKET}}
                  </td>
                  <td
                    class="has-text-centered td-heigher"
                  >
                    {{data.CUSTOMER}}
                  </td>
                  <td
                    class="has-text-centered td-heigher"
                  >
                    {{data.ORDERS}}
                  </td>
                  <td
                    class="has-text-centered td-heigher"
                  >
                    {{data.RIDER}}
                  </td>
                  <td
                    class="has-text-centered td-heigher"
                  >
                  <button class="button is-info" @click="yearPlanDetail(data.YEAR)">
                    ລາຍລະອຽດ
                  </button>
                  </td>

                  
                </tr>
              </tbody>
            </table>
          </b-field>
        </b-tab-item>
        <b-tab-item label="ລາຍລະອຽດ">
          <b-field :label="yearPlandProvinceListTitle">
            <table width="100%" class="table">
              <thead>
                <tr>
                  <th class="has-text-centered " width="5%">
                    #
                  </th>
                  <th class="has-text-left " width="30%">
                    ແຂວງ 
                  </th>
                  <th class="has-text-centered " width="15%">
                    ຈຳນວນ<br>ຕະຫຼາດ
                  </th>
                  <th class="has-text-centered " width="15%">
                    ຈຳນວນ<br>ລູກຄ້າ
                  </th>
                  <th class="has-text-centered " width="15%">
                    ຈຳນວນ<br>Order
                  </th>
                  <th class="has-text-centered " width="15%">
                    ຈຳນວນ<br>Rider
                  </th>
                  
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="(data, index) in yearPlandProvinceList"
                  :key="data.PROVINCEID"
                >
                  <td
                    class="has-text-centered td-heigher"
                  >
                    {{ index + 1 }}
                  </td>
                  <td
                    class="has-text-left td-heigher" 
                  >
                    {{data.PROVINCENAME}}
                  </td>
                  <td
                    class="has-text-centered td-heigher"
                  >
                    {{data.MARKET}}
                  </td>
                  <td
                    class="has-text-centered td-heigher"
                  >
                    {{data.CUSTOMER}}
                  </td>
                  <td
                    class="has-text-centered td-heigher"
                  >
                    {{data.ORDERS}}
                  </td>
                  <td
                    class="has-text-centered td-heigher"
                  >
                    {{data.RIDER}}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-field>
        </b-tab-item>
      </b-tabs>
    </div>

    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  data() {
    return {
      userName: null,
      roleid: null,
      activeTab: 0,
      
      provinceList: [],
      selectedYear: null,
      yearList: [],
      planByYearList: [],
      yearPlanTitle: "ຟອມແຜນປະຈຳປີ",
      yearPlanTitlebyYear: "ລາຍການແຜນປະຈຳປີ",
      yearPlandProvinceListTitle: "ລາຍລະອຽດແຜນປະຈຳປີ",

      yearOfPlanList: [],
      yearPlandProvinceList: [],
      
    };
  },
  methods: {

    

    saveDasmPlan(){
      var params = {
        year: this.selectedYear.YEAR,
        plan: this.provinceList,
        username: this.username
      };

      console.log("pararm:" + JSON.stringify(params))
      RestAPI.saveMarketPlan(params)
      .then(res => {
        

        if (res.data == "duplicate phoneno") {
          this.$swal(
            "ເບີໂທຊ້ຳ",
            "-",
            "error"
          );
          return false;
        }
          
        this.$swal("ບັນທຶກແຜນ ສຳເລັດ!", "", "success");
        
        this.getPlanProvinceList(this.selectedYear.YEAR);
        this.getPlanOfYear();
        // this.selectedYear = null;
        // console.log(res);
      })
      .catch(error => {
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });
      
    },

    onSelectedYear(){
      this.yearPlanTitle="ຟອມແຜນປະຈຳປີ "+ this.selectedYear.YEAR;
      this.yearPlanTitlebyYear ="ລາຍການແຜນປະຈຳປີ "+this.selectedYear.YEAR;
      this.getPlanProvinceList(this.selectedYear.YEAR);
    },

    getPlanProvinceList(year){
        
        RestAPI.getPlanMarketProvinceList(year)
        .then((res) => {
          this.provinceList = res.data.province;
          this.yearList = res.data.year;
          this.planByYearList = res.data.plan;
          console.log("pro: " + JSON.stringify(res.data))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    getPlanOfYear(){
      RestAPI.getMarketPlanOfYear(this.userBranchID)
        .then((res) => {
          this.yearOfPlanList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
      
    },
    yearPlanDetail(year){
      this.activeTab = 2;
      this.yearPlandProvinceListTitle ="ລາຍລະອຽດແຜນປະຈຳປີ " + year;
      RestAPI.yearMarketPlanDetail(year,this.userBranchID)
        .then((res) => {
          this.yearPlandProvinceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },



    clearPrintdata() {
      this.prepareidforprint = [];
      this.combineorderforprint = [];
      this.combineorderdetailforprint = [];
    },

    printReceipt(prepareid) {
      this.getMarketOnlineOrderDetailbyPrepareid(prepareid);
    },

    print() {
      window.print();
    },
  },
  mounted() {
    console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID
      ? this.user.BRANCHPROVNICEID
      : "all";
    this.userBranchID = this.user.DASMBRANCHID ?  this.user.DASMBRANCHID : 'all';
    this.currentDate = new Date();
    this.currentYear = this.currentDate.getUTCFullYear();
    this.getPlanProvinceList(this.currentYear);
    this.getPlanOfYear();
    if(this.roleid==6 || this.roleid==7){
      this.activeTab =1;
    }
    
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.td-heigher{
  height: 58px;
}
.very-important-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 40px;
}

/* .paymentdetailselected {
  margin-top: 5px;
  margin-bottom: 5px;
}
.paymentdetailselectedhightlight {
  font-weight: bold;
} */

.print-receipt {
  font-size: 10px;
}
.print-receipt-titel {
  font-size: 12px;
}
.print_table {
  font-size: 10px;
}
.print_tr {
  padding: 0px 0px 0px 0px;
}
.print_td {
  padding: 0px 0px 0px 0px !important;
  margin: 0px 0px 0px 0px !important;
  /* font-size: 20px; */
}
@media all {
  .page-break {
    display: none;
  }
}
@media print {
  @page {
    margin: -10px 0px 0px 0px !important;
    padding: -10px 0px 0px 0px !important;
    size: portrait;
  }
  .page-break {
    display: block;
    max-width: 99%;
  }
}
</style>
